const Wait = () => {
    return (
        <div className="Wait">
            <h1 className="Wait__Title">¡Prepárate!</h1>
            <p className="Wait__Text">Estamos por comenzar la dinámica</p>
            <p className="Welcome__Icon"><i className="bi bi-controller"></i></p>
            {/* <p className="Welcome__Icon"><i class="bi bi-file-play"></i></p> */}
            <p className="Welcome__Text">Aparecerá de manera automática</p>
            <p className="Welcome__Text Welcome__Text--Highlight"><i className="bi bi-exclamation-triangle"></i> Permanece en la página</p>
        </div>
    )
}

export { Wait };